import { getterTree, mutationTree, actionTree } from 'typed-vuex'

export const state = () => ({
  apiResponse: {
    state: 'calibration' as 'calibration' | 'scored',
    zone: null as 'red' | 'green' | 'blue' | null,
    percentage_value: null as number | null,
    score: null as number | null
  },
  isFetched: false,
  isFetching: false
})

export const getters = getterTree(state, {
  strategy(state) {
    return state.apiResponse
  }
})

export const mutations = mutationTree(state, {
  setApiResponse(state, payload: { state: 'calibration' | 'scored', zone: 'red' | 'green' | 'blue' | null, percentage_value: number | null, score: number | null }) {
    state.apiResponse = payload
  },
  setFetching(state, payload: boolean) {
    state.isFetching = payload
  },
  setFetched(state, payload: boolean) {
    state.isFetched = payload
  }
})

export const actions = actionTree({ state, getters, mutations }, {
  async fetchApplicationStrategy({ commit, state }) {
    if (state.isFetched || state.isFetching) { return }

    commit('setFetching', true)
    try {
      const response = await this.$axios.post('/graphql', {
        query: `
          query GetViewerApplicationHealth {
            viewer {
              stats {
                applicationStrategyHealth {
                  state
                  zone
                  percentageValue
                  score
                }
              }
            }
          }
        `
      }, {
        withCredentials: true
      })
      const health = response.data?.data?.viewer?.stats?.applicationStrategyHealth

      if (health) {
        commit('setApiResponse', {
          state: health.state.toLowerCase() === 'scored' ? 'scored' : 'calibration',
          zone: health.zone ? health.zone.toLowerCase() : null,
          percentage_value: health.percentageValue,
          score: health.score
        })
      }
      commit('setFetched', true)
    } catch (err) {
      this.$sentry.captureException(err)
    } finally {
      commit('setFetching', false)
    }
  }
})
